(() => {
  if (window.ampmFirstShift) return;
  const configEl = document.getElementById('AmpmFirstShiftConfig');
  if (!configEl) return;
  let config = {};
  try { config = JSON.parse(configEl.textContent); } catch (error) { return; }
  if (!config.company || !config.list) return;

  const REVISION = '2026-10-15';
  const KEYS = { joined: 'ampm_fs_joined', dismissed: 'ampm_fs_dismissed', touch: 'ampm_fs_touch', ref: 'ampm_fs_ref', email: 'ampm_fs_email', buyingFor: 'ampm_fs_for' };
  const store = (area) => ({
    get: (key) => { try { return window[area].getItem(key); } catch (error) { return null; } },
    set: (key, value) => { try { window[area].setItem(key, value); } catch (error) {} }
  });
  const local = store('localStorage');
  const session = store('sessionStorage');

  const params = new URLSearchParams(window.location.search);
  const UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  const ANSWERS = ['me', 'gift', 'both'];

  function readTouch() {
    let saved = {};
    try { saved = JSON.parse(local.get(KEYS.touch) || '{}'); } catch (error) { saved = {}; }
    const current = {};
    UTM_KEYS.forEach((key) => { if (params.get(key)) current[key] = params.get(key).slice(0, 120); });
    const ref = (params.get('ref') || '').replace(/[^a-z0-9]/gi, '').slice(0, 16);
    if (ref) current.referred_by = ref.toLowerCase();
    if (Object.keys(current).length) {
      saved = Object.assign({}, saved, current, { touched_at: Date.now() });
      local.set(KEYS.touch, JSON.stringify(saved));
    }
    if (saved.touched_at && Date.now() - saved.touched_at > 30 * 864e5) saved = {};
    return saved;
  }
  const touch = readTouch();

  function refCode() {
    let code = local.get(KEYS.ref);
    if (!code) {
      const bytes = new Uint8Array(6);
      window.crypto.getRandomValues(bytes);
      code = Array.from(bytes, (b) => 'abcdefghjkmnpqrstuvwxyz23456789'[b % 31]).join('');
      local.set(KEYS.ref, code);
    }
    return code;
  }

  function shareUrl(medium) {
    const url = new URL(config.share_url || '/pages/first-shift', window.location.origin);
    url.searchParams.set('ref', refCode());
    url.searchParams.set('utm_source', medium || 'share');
    url.searchParams.set('utm_medium', 'referral');
    return url.toString();
  }

  async function post(path, body) {
    const response = await fetch(`https://a.klaviyo.com/client/${path}?company_id=${encodeURIComponent(config.company)}`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', revision: REVISION },
      body: JSON.stringify(body)
    });
    if (response.status !== 202) throw new Error(`Klaviyo ${path} ${response.status}`);
  }

  function subscribe(email, source, label) {
    const properties = { signup_source: source, signup_page: window.location.pathname, ref_code: refCode() };
    UTM_KEYS.concat(['referred_by']).forEach((key) => { if (touch[key]) properties[key] = touch[key]; });
    const buyingFor = session.get(KEYS.buyingFor);
    if (ANSWERS.includes(buyingFor)) properties.buying_for = buyingFor;
    return post('subscriptions', {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: label,
          profile: { data: { type: 'profile', attributes: { email, properties, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } } } }
        },
        relationships: { list: { data: { type: 'list', id: config.list } } }
      }
    });
  }

  function updateProfile(email, attributes) {
    return post('profiles', { data: { type: 'profile', attributes: Object.assign({ email }, attributes) } });
  }

  const EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  function joined(source, email) {
    local.set(KEYS.joined, String(Date.now()));
    session.set(KEYS.email, email);
    document.dispatchEvent(new CustomEvent('ampm:first-shift-joined', { detail: { source } }));
    try { window.Shopify?.analytics?.publish?.('ampm_first_shift_joined', { source }); } catch (error) {}
  }

  function setBusy(form, busy) {
    const button = form.querySelector('[type="submit"]');
    if (!button) return;
    if (!button.dataset.label) button.dataset.label = button.textContent.trim();
    button.disabled = busy;
    button.textContent = busy ? (config.text_busy || 'Saving…') : button.dataset.label;
    form.setAttribute('aria-busy', busy ? 'true' : 'false');
  }

  function showError(form, message) {
    const box = form.querySelector('[data-ampm-fs-error]');
    if (!box) return;
    box.textContent = message;
    box.hidden = !message;
    const input = form.querySelector('input[type="email"]');
    if (input) input.setAttribute('aria-invalid', message ? 'true' : 'false');
  }

  function redirectTo(source) {
    const url = new URL(config.welcome_url || '/pages/first-shift-welcome', window.location.origin);
    url.searchParams.set('from', source);
    window.location.assign(url.toString());
  }

  function bindSignup(form) {
    if (form.dataset.ampmFsBound) return;
    form.dataset.ampmFsBound = '1';
    form.dataset.nocaptcha = 'true';
    const source = form.dataset.source || 'site';
    const label = form.dataset.label || 'AM/PM website';
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      event.stopImmediatePropagation();
      const input = form.querySelector('input[type="email"]');
      const email = (input?.value || '').trim();
      const trap = form.querySelector('[data-ampm-fs-trap]');
      if (!EMAIL.test(email)) { showError(form, config.text_invalid || 'Please check your email address.'); input?.focus(); return; }
      showError(form, '');
      if (trap && trap.value) { redirectTo(source); return; }
      setBusy(form, true);
      try {
        await subscribe(email, source, label);
        joined(source, email);
        redirectTo(source);
      } catch (error) {
        setBusy(form, false);
        showError(form, config.text_error || 'That didn’t work. Please try again.');
      }
    });
  }

  function bindThemeSignup(form) {
    if (form.dataset.ampmFsBound) return;
    const input = form.querySelector('input[type="email"]');
    if (!input) return;
    form.dataset.ampmFsBound = '1';
    form.dataset.nocaptcha = 'true';
    form.addEventListener('submit', async (event) => {
      if (form.dataset.ampmFsFallback) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      const email = input.value.trim();
      if (!EMAIL.test(email)) { input.setAttribute('aria-invalid', 'true'); input.focus(); return; }
      const button = form.querySelector('[type="submit"]');
      if (button) button.disabled = true;
      try {
        const tags = form.querySelector('input[name="contact[tags]"]')?.value || '';
        const place = /ampm-product/.test(tags) ? 'product' : 'footer';
        await subscribe(email, place, place === 'product' ? 'Product page' : 'Site footer');
        joined(place, email);
        redirectTo(place);
      } catch (error) {
        form.dataset.ampmFsFallback = '1';
        if (button) button.disabled = false;
        if (form.requestSubmit) form.requestSubmit(); else form.submit();
      }
    });
  }

  function bindWelcome(root) {
    const email = session.get(KEYS.email);
    const question = root.querySelector('[data-ampm-fs-for-wrap]');
    const nameWrap = root.querySelector('[data-ampm-fs-name-wrap]');
    const nameForm = root.querySelector('form[data-ampm-fs-name]');
    if (!email) return;
    const showName = () => { if (nameWrap) nameWrap.hidden = false; };
    if (question && !ANSWERS.includes(session.get(KEYS.buyingFor))) {
      question.hidden = false;
      question.querySelectorAll('[data-ampm-fs-for]').forEach((button) => {
        button.addEventListener('click', async () => {
          const answer = button.dataset.ampmFsFor;
          if (!ANSWERS.includes(answer)) return;
          session.set(KEYS.buyingFor, answer);
          question.querySelectorAll('[data-ampm-fs-for]').forEach((b) => { b.disabled = true; b.setAttribute('aria-pressed', b === button ? 'true' : 'false'); });
          try { await updateProfile(email, { properties: { buying_for: answer } }); } catch (error) {}
          const done = question.querySelector('[data-ampm-fs-for-done]');
          if (done) done.hidden = false;
          showName();
          nameWrap?.querySelector('input')?.focus({ preventScroll: true });
        });
      });
    } else {
      showName();
    }
    if (!nameForm) return;
    nameForm.addEventListener('submit', async (event) => {
      event.preventDefault();
      const input = nameForm.querySelector('input[name="first_name"]');
      const name = (input?.value || '').trim().slice(0, 60);
      if (!name) { input?.focus(); return; }
      setBusy(nameForm, true);
      try {
        await updateProfile(email, { first_name: name });
        const done = nameWrap.querySelector('[data-ampm-fs-name-done]');
        nameForm.hidden = true;
        if (done) { done.textContent = (done.dataset.template || 'Thanks, {name}.').replace('{name}', name); done.hidden = false; }
      } catch (error) {
        setBusy(nameForm, false);
        showError(nameForm, config.text_error || 'That didn’t work. Please try again.');
      }
    });
  }

  function bindShare(root) {
    root.querySelectorAll('[data-ampm-fs-share-url]').forEach((el) => { el.textContent = shareUrl('copy').replace(/^https?:\/\//, ''); });
    root.querySelectorAll('[data-ampm-fs-whatsapp]').forEach((link) => {
      link.href = `https://wa.me/?text=${encodeURIComponent(`${config.share_text || ''} ${shareUrl('whatsapp')}`.trim())}`;
    });
    root.querySelectorAll('[data-ampm-fs-copy]').forEach((button) => {
      button.addEventListener('click', async () => {
        const url = shareUrl('copy');
        if (navigator.share && window.matchMedia('(pointer: coarse)').matches) {
          try { await navigator.share({ text: config.share_text || '', url }); return; } catch (error) { if (error && error.name === 'AbortError') return; }
        }
        try { await navigator.clipboard.writeText(url); } catch (error) {}
        const original = button.dataset.label || button.textContent;
        button.dataset.label = original;
        button.textContent = config.text_copied || 'Link copied';
        setTimeout(() => { button.textContent = original; }, 2400);
      });
    });
  }

  function initPopup(dialog) {
    const teaser = document.querySelector('[data-ampm-fs-teaser]');
    const delay = Number(dialog.dataset.delay || 6) * 1000;
    const scrollShare = Number(dialog.dataset.scroll || 0) / 100;
    const days = Number(dialog.dataset.days || 7);
    const dismissedAt = Number(local.get(KEYS.dismissed) || 0);
    const stepQuestion = dialog.querySelector('[data-ampm-fs-step="question"]');
    const stepForm = dialog.querySelector('[data-ampm-fs-step="form"]');
    let opened = false;
    let timerDone = false;
    let scrolled = false;

    const showFormStep = () => {
      if (stepQuestion) stepQuestion.hidden = true;
      if (stepForm) stepForm.hidden = false;
      const heading = stepForm?.querySelector('h2');
      if (heading?.id) dialog.setAttribute('aria-labelledby', heading.id);
    };
    dialog.querySelectorAll('[data-ampm-fs-answer]').forEach((button) => {
      button.addEventListener('click', () => {
        const answer = button.dataset.ampmFsAnswer;
        if (ANSWERS.includes(answer)) session.set(KEYS.buyingFor, answer);
        showFormStep();
        stepForm?.querySelector('input[type="email"]')?.focus();
      });
    });

    const bannerVisible = () => {
      const banner = document.getElementById('shopify-pc__banner');
      return !!(banner && (banner.offsetWidth || banner.offsetHeight));
    };
    const open = (trigger) => {
      if (opened || dialog.open || local.get(KEYS.joined)) return;
      if (trigger !== 'teaser' && bannerVisible()) {
        opened = true;
        const wait = setInterval(() => {
          if (bannerVisible()) return;
          clearInterval(wait);
          setTimeout(() => { opened = false; open(trigger); }, 1500);
        }, 1000);
        return;
      }
      opened = true;
      dialog.dataset.trigger = trigger;
      if (ANSWERS.includes(session.get(KEYS.buyingFor))) showFormStep();
      if (teaser) teaser.hidden = true;
      dialog.showModal();
    };
    const dismiss = () => { if (dialog.open) dialog.close(); };
    dialog.addEventListener('close', () => {
      if (!local.get(KEYS.joined)) {
        local.set(KEYS.dismissed, String(Date.now()));
        if (teaser) teaser.hidden = false;
      } else if (teaser) {
        teaser.hidden = true;
      }
    });
    dialog.addEventListener('click', (event) => { if (event.target === dialog) dismiss(); });
    dialog.querySelectorAll('[data-ampm-fs-close]').forEach((button) => button.addEventListener('click', dismiss));
    if (teaser) {
      teaser.addEventListener('click', () => { opened = false; open('teaser'); });
      if (!local.get(KEYS.joined) && dismissedAt && Date.now() - dismissedAt < days * 864e5) teaser.hidden = false;
    }
    if (local.get(KEYS.joined)) return;
    if (dismissedAt && Date.now() - dismissedAt < days * 864e5) return;

    const tryOpen = () => { if (timerDone && scrolled) open('timer'); };
    setTimeout(() => { timerDone = true; tryOpen(); }, delay);
    const onScroll = () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollShare <= 0 || max <= 0 || window.scrollY / max >= scrollShare) { scrolled = true; window.removeEventListener('scroll', onScroll); tryOpen(); }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    if (window.matchMedia('(pointer: fine)').matches) {
      document.addEventListener('mouseout', (event) => {
        if (!event.relatedTarget && event.clientY <= 0 && performance.now() > 4000) open('exit');
      });
    }
  }

  function init() {
    document.querySelectorAll('form[data-ampm-fs-form]').forEach(bindSignup);
    if (config.footer) document.querySelectorAll('form.ampm-signup:not([data-ampm-fs-form])').forEach(bindThemeSignup);
    document.querySelectorAll('[data-ampm-fs-welcome]').forEach(bindWelcome);
    document.querySelectorAll('[data-ampm-fs-share]').forEach(bindShare);
    const dialog = document.querySelector('dialog[data-ampm-fs-popup]');
    if (dialog && typeof dialog.showModal === 'function') initPopup(dialog);
  }

  window.ampmFirstShift = { subscribe, updateProfile, shareUrl };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
